export default __webpack_public_path__ + "media/images/icon_profile_directory-b793c2f670b80656d4bbd334e07e92f0.png";